module.exports = __webpack_public_path__ + "img/duo-images-offset.da85d377.png";